import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "d-flex flex-nowrap justify-content-center gap-1" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "badge bg-light text-dark border fw-normal d-inline-flex align-items-center gap-2 px-2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-muted ms-2"
}

import { ref, computed, PropType } from "vue";
import type { TelegramChannel, AlertType } from "@/stores/telegramChannels";
import BaseChannelsTable from "./BaseChannelsTable.vue";
import {
  packageListIncludes,
  PKG_FLY,
  PKG_GO,
  PKG_WIN,
} from "functions/src/Subscriptions/packageIds";
// El color, el icono y el rótulo corto de cada paquete salen de la fuente
// única. Antes esta tabla tenía tres `switch` seguidos —uno por cosa— sobre el
// mismo `normalizeStoredPackageLabel`, y el de color mandaba GO a `bg-info`,
// que es literalmente el color de FLY. Al preguntar en vez de decidir, esa
// clase de error deja de poder repetirse fichero a fichero.
import PackageIcon from "@/components/common/PackageIcon.vue";
import { productVisual } from "@/components/common/productVisuals";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceChannelsTable',
  props: {
  channels: {
    type: Array as PropType<TelegramChannel[]>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["edit", "delete", "create", "refresh", "update-order"],
  setup(__props) {

const availablePackages = [PKG_GO, PKG_FLY, PKG_WIN];

const props = __props;



const showInactive = ref(false);
const filteredChannels = computed(() => {
  if (showInactive.value) return props.channels;
  return props.channels.filter((c) => c.active);
});

const formatAlertType = (type: AlertType) => {
  switch (type) {
    case "sports_betting":
      return "Deportes";
    case "forex":
      return "Forex";
    case "synthetic_indices":
      return "Índ. Sintéticos";
    default:
      return type;
  }
};

const getAlertIcon = (type: AlertType) => {
  switch (type) {
    case "sports_betting":
      return "fa-futbol";
    case "forex":
      return "fa-chart-line";
    case "synthetic_indices":
      return "fa-chart-area";
    default:
      return "fa-bell";
  }
};

// Aquí había tres funciones —`getPackageBadgeClass`, `getPackageIcon` y
// `formatPackageName`— que preguntaban lo mismo tres veces y respondían cada
// una por su cuenta. Las tres se fueron a `productVisuals`. La rama de CMMI que
// llevaban dentro tampoco se echa de menos: `availablePackages` es la lista
// cerrada de los tres niveles, así que por esta celda nunca pasó un `mmi-*`.

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseChannelsTable, {
    title: "Canales de Servicio",
    icon: "fa-bullhorn",
    iconClass: "",
    channels: filteredChannels.value,
    loading: __props.loading,
    mbClass: "mb-5",
    "show-inactive": showInactive.value,
    "onUpdate:showInactive": _cache[0] || (_cache[0] = ($event: any) => ((showInactive).value = $event)),
    onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit', $event))),
    onDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete', $event))),
    onCreate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('create'))),
    onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refresh'))),
    onUpdateOrder: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-order', $event)))
  }, {
    headers: _withCtx(() => [...(_cache[6] || (_cache[6] = [
      _createElementVNode("th", { class: "py-3 text-center" }, "Paquetes", -1),
      _createElementVNode("th", { class: "py-3 text-center" }, "Monitoreo", -1),
      _createElementVNode("th", { class: "py-3" }, "Tipo de Alerta", -1)
    ]))]),
    row: _withCtx(({ channel }) => [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availablePackages, (pkg) => {
            return _createElementVNode("span", {
              key: pkg,
              class: _normalizeClass(["badge fw-normal rounded-pill d-inline-flex align-items-center gap-1 px-1", 
              _unref(packageListIncludes)(channel.availableForPackage, pkg)
                ? _unref(productVisual)(pkg).bgClass
                : 'bg-light text-muted border opacity-50 grayscale'
            ])
            }, [
              _createVNode(PackageIcon, {
                product: pkg,
                "extra-class": "small"
              }, null, 8, ["product"]),
              _createTextVNode(" " + _toDisplayString(_unref(productVisual)(pkg).shortLabel), 1)
            ], 2)
          }), 64))
        ])
      ]),
      _createElementVNode("td", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas", 
            channel.monitoringEnabled
              ? 'fa-check-circle text-success'
              : 'fa-times-circle text-muted'
          ])
        }, null, 2)
      ]),
      _createElementVNode("td", null, [
        (channel.monitoringEnabled && channel.alertsType)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-fw text-muted", getAlertIcon(channel.alertsType)])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(formatAlertType(channel.alertsType)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
      ])
    ]),
    _: 1
  }, 8, ["channels", "loading", "show-inactive"]))
}
}

})